import { ReactElement, useState } from "react";
import {
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography, useTheme
} from "@mui/material";
import { IRowData } from "../types";
import { formatDateTimeWithSeconds, toTons } from "../../../system/utils";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface IProps{
  index: number;
  row: IRowData;
  selectedItem: IRowData | null;
  setSelectedItem: (item: IRowData) => void;
}

const ProductionTableGroupedRow = ({ row, selectedItem, setSelectedItem, index }: IProps): ReactElement => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow hover={true} role="checkbox" tabIndex={-1}
        onClick={() => setSelectedItem(row)} selected={row === selectedItem}
        style={{ backgroundColor: index % 2 ? theme.palette.action.hover : undefined }}>
        <TableCell>
          <div className="display-flex-row">
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </div>
        </TableCell>
        <TableCell>
          {formatDateTimeWithSeconds(row.beginDatetime)}
        </TableCell>
        <TableCell>
          {formatDateTimeWithSeconds(row.endDatetime)}
        </TableCell>
        <TableCell align="right">
          {row.totalBillets}
        </TableCell>
        <TableCell align="right">
          {toTons(row.totalWeight).toFixed(2)}
        </TableCell>
        <TableCell className="w-100"/>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, border: "none" }} colSpan={3} aria-colindex={2}>
          <Collapse in={open} timeout="auto" unmountOnExit={true}>
            <Box sx={{ m: 1 }}>
              <Typography variant="h6" gutterBottom={true} component="div">
                Detail
              </Typography>
              <Table stickyHeader={true} size={"small"}>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-header" >Machine</TableCell>
                    <TableCell className="table-header" align="right" >Total Billets</TableCell>
                    <TableCell className="table-header" align="right" >Total Weight <sub>[US ton]</sub></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.machineDetail.map((machineData, indexM) => {
                    return(
                      <TableRow key={`detail-${index}-${machineData.name}-${indexM}`} hover={true}>
                        <TableCell>{machineData.name}</TableCell>
                        <TableCell align="right" >{machineData.totalBillets}</TableCell>
                        <TableCell align={"right"}>{toTons(machineData.totalWeight).toFixed(2)}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );

};

export default ProductionTableGroupedRow;
